import { SignUpScreen } from 'app/features/auth/screens'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page(props: any) {
  return <SignUpScreen {...props} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req, query }) => {
  const user = req?.session?.user

  if (user?.token) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    }
  }

  return {
    props: query,
  }
})
